import {list} from '@/domain/pessoa/services'
export default function (terms) {
    let filtros = encodeURI(`&tipo=2&sortBy=name&descending=false&search=${terms}`)
    return list(50, 1, filtros)
}